import { createCommand } from '../../utils';
import { networkSectionsFilterQuery, networkSectionsSortQuery } from '../queries';
import { moduleName, resetStarted, resetWith } from '../state';

export const InitNetworkCommand = createCommand(
    `${moduleName}/INIT_NETWORK`,
    async (_, { dispatch, extra, getState }) => {
        dispatch(resetStarted());
        const networkSections = await extra.externalNetwork.loadNetworkSections();
        const state = getState();

        let sort = networkSectionsSortQuery(state);
        if (sort.length === 0) {
            sort = extra.externalNetworkConfiguration.loadNetworkSectionsSort();
        }
        let filter = networkSectionsFilterQuery(state);
        if (filter.items.length === 0) {
            filter = extra.externalNetworkConfiguration.loadNetworkSectionsFilter();
        }
        dispatch(resetWith({ networkSections, sort, filter }));
    },
);
